<template>
  <div v-if="customer" class="on-board">
    <on-board-card-view v-if="!hasCard" />
    <on-board-requirements-view v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnBoardCardView from "@/views/Account/OnBoard/CardView";
import OnBoardRequirementsView from "@/views/Account/OnBoard/RequirementsView";
import { alias } from "@/utils/helpers";

export default {
  name: "OnBoardView",
  components: {
    OnBoardRequirementsView,
    OnBoardCardView,
  },
  computed: {
    ...mapGetters("customers", ["customer"]),
    ...alias("customer.hasCard", "hasCard"),
    canView() {
      return this.customer && !this.customer.hasActiveCard;
    },
  },
  watch: {
    canView: {
      handler(value) {
        if (value) {
          return;
        }

        this.$router.push({ name: "my-plane" });
      },
      immediate: true,
    },
  },
  methods: {
    async onChangeUser() {
      await this.$auth.logout();
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.on-board {
  min-height: calc(100vh - 4.125rem);
  max-width: 23.75rem;
  margin: auto;
  color: $white;
}
</style>
